import { gql } from '@src/lib/gql'

export const ADVISOR_AGREEMENT_PDF = gql`
  query AdvisorAgreementPdf($advisorAgreementId: String, $sourceKey: String) {
    advisorAgreementPdf(advisorAgreementId: $advisorAgreementId, sourceKey: $sourceKey) {
      fileName
      mimeType
      sourceKey
      contentBase64
    }
  }
`

export const ADVISOR_COMP_OVERVIEW_PDF = gql`
  query AdvisorCompOverviewPdf(
    $companyStageKey: String
    $contributionTierKey: String
    $caliberKey: String
    $warmIntroKey: String
    $hoursPerMonth: Int
    $valuationInDollars: Float
  ) {
    advisorCompOverviewPdf(
      companyStageKey: $companyStageKey
      contributionTierKey: $contributionTierKey
      caliberKey: $caliberKey
      warmIntroKey: $warmIntroKey
      hoursPerMonth: $hoursPerMonth
      valuationInDollars: $valuationInDollars
    ) {
      fileName
      mimeType
      sourceKey
      contentBase64
    }
  }
`
